import React, { useRef } from "react";
import { compose } from "redux";
import ContactListContainerAI from "./existingCompTORender/ContactListContainerAI";
import OppTableContainer from "./existingCompTORender/OppTableContainer";
import OppCardViewContainer from "./OppCardViewContainer";
import { Download } from "react-feather"; 
import html2pdf from "html2pdf.js";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { normalizeMappedProducts } from "../../../utilities/uiUtils";
import * as XLSX from "xlsx";
import TOGenericDownloadComp from "./TOGenericDownloadComp";
const getBase64FromUrl = async (url) => {
  const res = await fetch(url);
  const blob = await res.blob();

  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
};

const handleDownloadContactsExcel = (contacts) => {
  if (!contacts || contacts.length === 0) return;

  const excelRows = contacts.map((cnt) => ({
    "Contact Name": cnt?.name || "-",
    "Designation": cnt?.title || "-",
    "Organisation": cnt?.organization?.name || "-",
    "Location": cnt?.city + "," + (cnt?.country || "") || "-",
    "LinkedIn URL": cnt?.linkedin_url || "-",
  }));

  const worksheet = XLSX.utils.json_to_sheet(excelRows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Contacts");

  XLSX.writeFile(workbook, "Contacts_List.xlsx");
};

const INTENT_TYPES = {
  RENDER_CONTACT: "RENDER_CONTACT",
  RENDER_OPPS: "RENDER_OPPS",
  RENDER_GENERIC:"RENDER_GENERIC"
};

function ChatMessagesContainerCompsRenderer({ intentData, setIntentData }) {
  const pdfRef = useRef(null);
  const genericRef = useRef(null);     // 🔥 REQUIRED FOR GENERIC DOWNLOAD

  if (!intentData?.intent) return null;
  
  const { intent, data } = intentData;

const cleanPdfText = (str) => {
  if (!str) return "-";

  return String(str)
    .normalize("NFKD")

    // Replace ALL kinds of Unicode hyphens with ASCII hyphen "-"
    .replace(/[\u2010\u2011\u2012\u2013\u2014\u2015\u2212]/g, "-")

    // Replace smart quotes
    .replace(/[“”]/g, '"')
    .replace(/[‘’]/g, "'")

    // Remove invisible characters + control chars
    .replace(/[\u0000-\u001F\u007F]/g, " ")
    .replace(/\u2028|\u2029/g, " ")

    // Normalize newlines
    .replace(/(\r\n|\n|\r)/gm, " ")

    .replace(/\s\s+/g, " ")
    .trim();
};


  const handleDownload = async () => {
    if (!data) return;

    const HEADER_HEIGHT = 40;
    const FOOTER_HEIGHT = 40;
    const PAGE_WIDTH = 595;
    const MARGIN_TOP = HEADER_HEIGHT + 40;
    const MARGIN_BOTTOM = FOOTER_HEIGHT ;
    const CONTENT_WIDTH = PAGE_WIDTH - 80;

    const LABEL_SPACING = 22;
    const LINE_SPACING = 18;
    const FIELD_GAP = 25;

    const doc = new jsPDF({ unit: "pt", format: "a4" });

    const logoBase64 = await getBase64FromUrl("/img/mnm_logo_white.png");

    const drawHeader = () => {
      doc.setFillColor(20, 90, 129); 
      doc.rect(0, 0, PAGE_WIDTH, HEADER_HEIGHT, "F");

      const logoWidth = 130;
      const logoHeight = 20;

      doc.addImage(
        logoBase64,
        "PNG",
        PAGE_WIDTH - logoWidth - 20,
        20,
        logoWidth,
        logoHeight
      );
    };

    const drawFooter = () => {
      doc.setFillColor(20, 90, 129); 
      doc.rect(
        0,
        doc.internal.pageSize.height - FOOTER_HEIGHT,
        PAGE_WIDTH,
        FOOTER_HEIGHT,
        "F"
      );

      doc.setFont("helvetica", "normal");
      doc.setFontSize(10);
      doc.setTextColor("#ffffff");
      doc.text(
        `Generated on: ${new Date().toLocaleDateString()}`,
        20,
        doc.internal.pageSize.height - 15
      );
      doc.setTextColor("#000000");
    };

    drawHeader();
    drawFooter();

    doc.setFont("helvetica", "bold");
    doc.setFontSize(22);

    const title = "Opportunities Report";
    const titleWidth = doc.getTextWidth(title);
    const titleX = (PAGE_WIDTH - titleWidth) / 2;

    doc.text(title, titleX, MARGIN_TOP);

    let y = MARGIN_TOP + 40;

    doc.setFont("helvetica", "normal");
    doc.setFontSize(14);

    // doc.text(`Total Opportunities: ${data.length}`, 40, y);
    // y += 30;

    data.forEach((item, index) => {
      if (index > 0) {
        doc.addPage();
        drawHeader();
        drawFooter();
        y = MARGIN_TOP;
      }

      doc.setFont("helvetica", "bold");
      doc.setFontSize(16);
      doc.text(`Opportunity ${index + 1}`, 40, y);
      y += 30;

      const fields = [
        { label: "Name", value: item.opportunity_name || "-" },
        { label: "Description", value: item.opportunity_description || "-" },
        { label: "Offerings", value: normalizeMappedProducts(item.mapped_products) || "-" },
        { label: "Relevance", value: item.relevance || "-" },
        { label: "Signal", value: item.signal || "-" }
      ];

      fields.forEach(({ label, value }) => {
        doc.setFont("helvetica", "bold");
        doc.setFontSize(12);
        doc.text(`${label}:`, 40, y);
        y += LABEL_SPACING;

        doc.setFont("helvetica", "normal");
        let cleanValue = cleanPdfText(value);
        const wrapped = doc.splitTextToSize(cleanValue, CONTENT_WIDTH);
        

        wrapped.forEach(line => {
          doc.text(line, 40, y);
          y += LINE_SPACING;

          if (y > doc.internal.pageSize.height - MARGIN_BOTTOM) {
            doc.addPage();
            drawHeader();
            drawFooter();
            y = MARGIN_TOP;
          }
        });

        y += FIELD_GAP;
      });

      // doc.setDrawColor(170);
      // doc.line(40, y, PAGE_WIDTH - 40, y);
      // y += 25;
    });

    doc.save("opportunities.pdf");
  };

  /* ----------------------------- RENDERING BY INTENT ----------------------------- */
  const renderByIntent = () => {
    switch (intent) {
      case INTENT_TYPES.RENDER_CONTACT:
        return <ContactListContainerAI data={data} />;

      case INTENT_TYPES.RENDER_OPPS:
        console.log(data);
        return <OppCardViewContainer data={data} />;

      case INTENT_TYPES.RENDER_GENERIC:
        
        return <TOGenericDownloadComp ref={genericRef} htmlString={data} />;

      default:
        return null;
    }
  };

  return (
    <div style={wrapperStyle}>

      {/* ------------------ OPPORTUNITIES PDF DOWNLOAD ------------------ */}
      {intent === INTENT_TYPES.RENDER_OPPS && (
        <button style={downloadBtnStyle} onClick={handleDownload}>
          <Download size={16} />
        </button>
      )}

      {/* ------------------ CONTACTS EXCEL DOWNLOAD ------------------ */}
      {intent === INTENT_TYPES.RENDER_CONTACT && (
        <button
          style={downloadBtnStyle}
          onClick={() => handleDownloadContactsExcel(data)}
        >
          <Download size={16} />
        </button>
      )}

      {/* ------------------ GENERIC HTML → PDF DOWNLOAD ------------------ */}
      {intent === INTENT_TYPES.RENDER_GENERIC && (
        <button
          style={downloadBtnStyle}
          onClick={() => genericRef.current?.print()}
        >
          <Download size={16} />
        </button>
      )}


      {/* ------------------ CLOSE BUTTON ------------------ */}
      <button
        onClick={() => setIntentData({ intent: null })}
        style={closeBtnStyle}
      >
        ✕
      </button>

      <div ref={pdfRef} style={{ height: "100%", overflowY: "auto", overflowX: "hidden" }}>
        {renderByIntent()}
      </div>

    </div>
  );
}

export default ChatMessagesContainerCompsRenderer;

/* ----------------------------- STYLES ----------------------------- */

const wrapperStyle = {
  position: "relative",
  height: "100%",
  width: "100%",
  background: "#fff",
};

const closeBtnStyle = {
  position: "absolute",
  top: "0.6rem",
  right: "1.2rem",
  background: "#f0f0f0",
  border: "none",
  borderRadius: "50%",
  width: "28px",
  height: "28px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  fontSize: "1rem",
  fontWeight: "600",
  color: "#333",
  boxShadow: "none",
  transition: "all 0.2s ease",
  zIndex: 100
};

const downloadBtnStyle = {
  position: "absolute",
  top: "0.6rem",
  right: "4rem",
  background: "#f0f0f0",
  border: "none",
  borderRadius: "50%",
  width: "28px",
  height: "28px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  boxShadow: "none",
  transition: "all 0.2s ease",
  zIndex: 100,
};
